import React from "react";
import { DefaultHomePage } from "@firecms/core";
import { HomeStats } from "./HomeStats";
import { homeStats } from "./home_stats";

export function HomePageWithStats() {
    return <DefaultHomePage additionalChildrenStart={<HomeStats stats={homeStats} />} />;
}
